import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import Dropdown from 'react-toolbox/lib/dropdown'

import styles from './styles.scss'

const StyledDropdown = props => {
  const { styles, ...rest } = props
  return (
    <Dropdown
      {...rest}
      theme={styles}
    />
  )
}

StyledDropdown.propTypes = {}

export default CSSModules(styles, StyledDropdown)
